import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "walkFilled"
const WalkFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M11.104 17.534 10.601 18.846 10.5 19.106 7.677 21.928C7.166 22.44 6.335 22.44 5.822 21.928 5.31 21.415 5.31 20.585 5.822 20.072L8.25 17.644 9.162 15.27z" />
          <path d="M9.904 7.198C10.775 6.928 11.699 6.867 12.598 7.02 13.369 7.15 14.104 7.435 14.76 7.855 15.131 8.093 15.392 8.418 15.56 8.75L15.627 8.892 16.413 10.717 17.925 11.624C18.547 11.997 18.75 12.804 18.375 13.425 18.004 14.047 17.197 14.248 16.576 13.875L14.7 12.752 14.337 12.533 14.093 11.968 13.56 14.104 15.799 16.591 15.882 16.873 17.007 20.623C17.215 21.317 16.821 22.048 16.127 22.257S14.702 22.07 14.493 21.377L13.453 17.91 12.369 16.705 9.722 13.62C9.57 13.286 9.536 12.897 9.662 12.52L10.589 9.737C10.147 9.889 9.744 10.135 9.409 10.46 9.048 10.808 8.775 11.236 8.612 11.71 8.376 12.393 7.629 12.757 6.943 12.52 6.259 12.285 5.896 11.538 6.132 10.853 6.43 9.99 6.926 9.21 7.581 8.574 8.237 7.94 9.033 7.468 9.904 7.198M13.875 1.5C15.118 1.5 16.125 2.507 16.125 3.75S15.118 6 13.875 6C12.633 6 11.625 4.993 11.625 3.75S12.633 1.5 13.875 1.5" />
        </svg>
      }
    </span>
  )
}
export default WalkFilledIcon
